import { render, staticRenderFns } from "./AlbumItemCard.vue?vue&type=template&id=e9309aa0&scoped=true&"
import script from "./AlbumItemCard.vue?vue&type=script&lang=ts&"
export * from "./AlbumItemCard.vue?vue&type=script&lang=ts&"
import style0 from "./AlbumItemCard.vue?vue&type=style&index=0&id=e9309aa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9309aa0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VBtn,VCard,VCheckbox,VIcon,VSpacer})
